import { render, staticRenderFns } from "./scene_8.vue?vue&type=template&id=8df44340&"
import script from "./scene_8.vue?vue&type=script&lang=ts&"
export * from "./scene_8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports